import React, {Component} from 'react';
import TableFilter from 'react-table-filter';


export class Filter extends Component {
    constructor(props) {
        super(props);

        this._headerText = this._headerText.bind(this);
    }

    _headerText(columnKey) {
        switch (columnKey) {
            case 'colorwayName':
                return 'COLORWAY NAME';
            case 'nikeDevColorwayType':
                return 'DEV COLORWAY TYPE';
            case 'nikeDevColorwaySeasonStatus':
                return 'DEV COLORWAY SEASON STATUS';
            case 'nikeProductOfferingId':
                return 'PRODUCT OFFERING ID';
            case 'nikeProductID':
                return 'PRODUCT ID';
            case 'nikeDevColorwayID':
                return 'DEV COLORWAY ID';
            case 'cycleYearAbbreviation':
                return 'SEASON';
            case 'lineEvolutionDescription':
                return 'LINE EVOLUTION';
            case 'styleName':
                return 'DEV STYLE NAME';
            default:
                return 'Missing';
        }
    }

    render() {

        return (
            <div>
                <table className="filtertable" key={this.props.columnKey}>
                    <tbody key={this.props.columnKey} >
                        <TableFilter
                            key={this.props.columnKey}
                            rows={this.props.rowData}
                            onFilterUpdate={this.props.onFilterUpdate}
                        >
                            <th filterkey={this.props.columnKey} key={this.props.columnKey} className="cell">
                                {this._headerText(this.props.columnKey)}
                            </th>
                            <th key={`${this.props.columnKey}+1`} />
                        </TableFilter>
                    </tbody>
                </table>
            </div>
        );
    }

}

export default Filter;


// WEBPACK FOOTER //
// ./src/Components/Filter.js